// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gyramais-btn {
  background-color: var(--primary-button-color);
  color: var(--primary-button-text-color);
  border: none;
  min-height: 3.25rem;
  border-radius: 1.25rem;
  margin: 0;
  padding: 1.25rem 1.5rem;
  transition: 0.6s;
  cursor: pointer;
  outline: none;
  line-height: 1.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gyramais-btn:hover {
  color: var(--primary-button-text-color);
  text-decoration: none !important;
}
.gyramais-btn span,
.gyramais-btn div {
  font-weight: 500;
  font-size: 1.125rem;
  flex-wrap: wrap;
}
.gyramais-btn.gyramais-btn-loading {
  cursor: wait;
}
.gyramais-btn.gyramais-btn-loading .ant-spin {
  line-height: 0;
}
.gyramais-btn.gyramais-btn-loading .ant-spin .anticon {
  font-size: 1.3rem !important;
}
.gyramais-btn.gyramais-btn-primary {
  background-color: var(--primary-button-color) !important;
  color: var(--primary-button-text-color) !important;
}
.gyramais-btn.gyramais-btn-secondary {
  background-color: var(--secondary-button-color);
  color: var(--secondary-button-text-color);
}
.gyramais-btn.gyramais-btn-white {
  background-color: #F2F2F2;
  color: #000000;
}
.gyramais-btn.gyramais-btn-success {
  background-color: var(--success-color);
  color: #ffffff;
}
.gyramais-btn.gyramais-btn-warning {
  background-color: var(--warning-color);
  color: #ffffff;
}
.gyramais-btn.gyramais-btn-danger {
  background-color: var(--danger-color);
  color: #ffffff;
}
.gyramais-btn.gyramais-btn-basic {
  border: 1px solid #C9D3CC;
  background-color: #ffffff;
  color: #000000;
}
.gyramais-btn.gyramais-btn-basic > .anticon {
  color: var(--primary-button-color);
}
.gyramais-btn.gyramais-btn-link {
  background: none;
  border: none;
  color: var(--link-button-color);
  padding: 0;
  min-height: 2rem;
}
.gyramais-btn.gyramais-btn-link > .anticon {
  font-size: 1.2rem;
}
.gyramais-btn.gyramais-btn-link:hover {
  filter: brightness(1.3);
}
.gyramais-btn.gyramais-btn-link .link-button-icon {
  margin-right: 0.5rem;
}
.gyramais-btn.gyramais-btn-bordered {
  background-color: #ffffff;
  border: 2px solid var(--primary-button-color);
  border-radius: 1rem;
}
.gyramais-btn.gyramais-btn-bordered.only-icon > .anticon {
  color: var(--primary-button-color);
}
.gyramais-btn.gyramais-btn-icon {
  display: flex;
  align-items: center;
}
.gyramais-btn.gyramais-btn-icon.only-icon {
  transition: 0s !important;
  min-height: 3.25rem;
  min-width: 3.25rem;
  padding: 0.6rem;
}
.gyramais-btn.gyramais-btn-icon.only-icon > .anticon {
  font-size: 1.4rem;
}
.gyramais-btn.gyramais-btn-icon.only-icon.gyramais-btn-loading {
  padding: 0.4rem !important;
}
.gyramais-btn.gyramais-btn-action {
  min-height: 0 !important;
  min-width: 0 !important;
  padding: 0.2rem !important;
  background-color: transparent;
  border: 1px solid #C9D3CC;
  border-radius: 0.5rem;
}
.gyramais-btn.gyramais-btn-action > .anticon {
  font-size: 1.2rem !important;
  color: var(--primary-button-color);
}
.gyramais-btn.gyramais-btn-action.gyramais-btn-large {
  height: auto;
  padding: 0.625rem !important;
  border-radius: 0.7rem;
}
.gyramais-btn:disabled {
  cursor: not-allowed;
  text-decoration: none !important;
  opacity: 0.5;
  color: #000000;
  background-color: #f0f0f0;
}
.gyramais-btn:disabled.gyramais-btn-link {
  background: none;
}
.gyramais-btn:disabled svg {
  fill: gray;
}
.gyramais-btn:hover {
  filter: brightness(0.95);
}
.gyramais-btn:hover:disabled {
  filter: brightness(1);
}
.gyramais-btn-text {
  cursor: pointer;
}
.gyramais-btn-text.gyramais-btn-text-link {
  color: var(--link-button-color);
  text-decoration: underline;
  font-weight: 500;
}
.gyramais-btn-text.gyramais-btn-text-link:hover {
  color: var(--link-button-color);
}
.gyramais-btn-large {
  height: 3.75rem;
}
.gyramais-btn-large span,
.gyramais-btn-large div {
  font-size: 1.25rem;
}
.gyramais-btn-small {
  min-height: 0;
  padding: 0.75rem;
  border-radius: 0.5rem;
}
.gyramais-btn-small span,
.gyramais-btn-small div {
  font-size: 0.75rem;
  line-height: 0.5rem;
}
.gyramais-btn-block {
  width: 100%;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/components/sdk/Button/styles.less"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,uCAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,uCAAA;EACA,gCAAA;AACJ;AAnBA;;EAsBI,gBAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAEE;EACE,YAAA;AAAJ;AADE;EAII,cAAA;AAAN;AAJE;EAOM,4BAAA;AAAR;AAKE;EACE,wDAAA;EACA,kDAAA;AAHJ;AAME;EACE,+CAAA;EACA,yCAAA;AAJJ;AAOE;EACE,yBAAA;EACA,cAAA;AALJ;AAQE;EACE,sCAAA;EACA,cAAA;AANJ;AASE;EACE,sCAAA;EACA,cAAA;AAPJ;AAUE;EACE,qCAAA;EACA,cAAA;AARJ;AAWE;EACE,yBAAA;EACA,yBAAA;EACA,cAAA;AATJ;AAME;EAMI,kCAAA;AATN;AAaE;EACE,gBAAA;EACA,YAAA;EACA,+BAAA;EACA,UAAA;EACA,gBAAA;AAXJ;AAME;EAQI,iBAAA;AAXN;AAcI;EACE,uBAAA;AAZN;AAAE;EAeI,oBAAA;AAZN;AAiBE;EACE,yBAAA;EACA,6CAAA;EACA,mBAAA;AAfJ;AAiBI;EAEI,kCAAA;AAhBR;AAqBE;EACE,aAAA;EACA,mBAAA;AAnBJ;AAqBI;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAnBN;AAeI;EAOI,iBAAA;AAnBR;AAsBM;EACE,0BAAA;AApBR;AAyBE;EACE,wBAAA;EACA,uBAAA;EACA,0BAAA;EAEA,6BAAA;EACA,yBAAA;EACA,qBAAA;AAxBJ;AAiBE;EAUI,4BAAA;EACA,kCAAA;AAxBN;AA2BI;EACE,YAAA;EACA,4BAAA;EAEA,qBAAA;AA1BN;AA8BE;EACE,mBAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;AA5BJ;AA8BI;EACE,gBAAA;AA5BN;AAoBE;EAYI,UAAA;AA7BN;AAiCE;EACE,wBAAA;AA/BJ;AAiCI;EACE,qBAAA;AA/BN;AAoCA;EACE,eAAA;AAlCF;AAoCE;EACE,+BAAA;EACA,0BAAA;EACA,gBAAA;AAlCJ;AAoCI;EACE,+BAAA;AAlCN;AAuCA;EACE,eAAA;AArCF;AAoCA;;EAII,kBAAA;AApCJ;AAwCA;EACE,aAAA;EACA,gBAAA;EACA,qBAAA;AAtCF;AAmCA;;EAMI,kBAAA;EACA,mBAAA;AArCJ;AAyCA;EACE,WAAA;EACA,eAAA;AAvCF","sourcesContent":[".gyramais-btn {\n  background-color: var(--primary-button-color); \n  color: var(--primary-button-text-color);\n  border:none;\n  min-height: 3.25rem;\n  border-radius: @border-radius;\n  margin:0;\n  padding: 1.25rem 1.5rem;\n  transition: .6s;\n  cursor: pointer;\n  outline: none;\n  line-height: 1.35rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  \n  &:hover {\n    color: var(--primary-button-text-color);\n    text-decoration: none !important;\n  }\n\n  span, div {\n    font-weight: 500;\n    font-size: 1.125rem;\n    flex-wrap: wrap;\n  }\n\n  &.gyramais-btn-loading {\n    cursor: wait;\n\n    .ant-spin {\n      line-height: 0;\n\n      .anticon {\n        font-size: 1.3rem !important;\n      }\n    }\n  }\n\n  &.gyramais-btn-primary {\n    background-color: var(--primary-button-color) !important; \n    color: var(--primary-button-text-color) !important;\n  }\n\n  &.gyramais-btn-secondary {\n    background-color: var(--secondary-button-color); \n    color: var(--secondary-button-text-color);\n  }\n\n  &.gyramais-btn-white {\n    background-color: #F2F2F2;\n    color: #000000;\n  }\n\n  &.gyramais-btn-success {\n    background-color: var(--success-color);\n    color: #ffffff;\n  }\n\n  &.gyramais-btn-warning {\n    background-color: var(--warning-color);\n    color: #ffffff;\n  }\n\n  &.gyramais-btn-danger {\n    background-color: var(--danger-color);\n    color: #ffffff;\n  }\n\n  &.gyramais-btn-basic {\n    border: 1px solid #C9D3CC;\n    background-color: #ffffff;\n    color: #000000;\n\n    >.anticon {\n      color: var(--primary-button-color);\n    }\n  }\n\n  &.gyramais-btn-link {\n    background: none;\n    border: none;\n    color: var(--link-button-color);\n    padding: 0;\n    min-height: 2rem;\n\n    >.anticon {\n      font-size: 1.2rem;\n    }\n    \n    &:hover {\n      filter: brightness(1.3);\n    }\n    .link-button-icon {\n      margin-right: .5rem;\n\n    }\n  }\n\n  &.gyramais-btn-bordered {\n    background-color: #ffffff;\n    border: 2px solid var(--primary-button-color);\n    border-radius: 1rem;\n\n    &.only-icon {\n      > .anticon {\n        color: var(--primary-button-color);\n      }\n    }\n  }\n\n  &.gyramais-btn-icon {\n    display: flex;\n    align-items: center;\n\n    &.only-icon {\n      transition: 0s !important;\n      min-height: 3.25rem;\n      min-width: 3.25rem;\n      padding: .6rem;\n\n      > .anticon {\n        font-size: 1.4rem;\n      }\n\n      &.gyramais-btn-loading {\n        padding: .4rem !important;\n      }\n    }\n  }\n\n  &.gyramais-btn-action {\n    min-height: 0 !important;\n    min-width: 0 !important;\n    padding: .2rem !important;\n    \n    background-color: transparent;\n    border: 1px solid #C9D3CC;\n    border-radius: .5rem;\n\n    > .anticon {\n      font-size: 1.2rem !important;\n      color: var(--primary-button-color);\n    }\n\n    &.gyramais-btn-large {\n      height: auto;\n      padding: .625rem !important;\n      \n      border-radius: .7rem;\n    }\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    text-decoration: none !important;\n    opacity: 0.5;\n    color: #000000;\n    background-color: #f0f0f0;\n\n    &.gyramais-btn-link{\n      background: none;\n    }\n\n    svg{\n      fill: gray;\n    }\n  }\n\n  &:hover {\n    filter: brightness(0.95);\n\n    &:disabled {\n      filter: brightness(1);\n    }\n  }\n}\n\n.gyramais-btn-text {\n  cursor: pointer;\n\n  &.gyramais-btn-text-link {\n    color: var(--link-button-color);\n    text-decoration: underline;\n    font-weight: 500;\n\n    &:hover {\n      color: var(--link-button-color);\n    }\n  }\n}\n\n.gyramais-btn-large {\n  height: 3.75rem;\n\n  span, div {\n    font-size: 1.25rem;\n  }\n}\n\n.gyramais-btn-small {\n  min-height: 0;\n  padding: .75rem;\n  border-radius: .5rem;\n\n  span, div {\n    font-size: .75rem;\n    line-height: .5rem;\n  }\n}\n\n.gyramais-btn-block {\n  width:100%;\n  max-width: 100%;\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
